import { SelectItem } from './SelectIem'
import DOMPurify from 'dompurify'

export interface ApiResponse<T = any> {
  result: T
}

export interface IObject {
  value: number | string | boolean
  text: string
}

export interface IPaginationFilter {
  offset: number
  size: number
}
export interface IReportRefDataDTO {
  id: string
  name: string
  index: number
}

export interface IRefDataDTO {
  id: string
  name: string
  officialName?: string //country uses this field instead of name field
  displayOrder: number
}

export interface IRFAInfoSubCategoryDTO {
  id: string
  name: string
  displayOrder: number
  idRFAICM: string
}

export interface ISubIndustryRefDataDTO {
  id: string
  name: string
  displayOrder: number
  idIndustryFilter: string
  idSubIndustryFilter: string
}

export interface IApiErrorResponse {
  status: number
  message: string
  detail: string
  errors?: any
}

export class ApiErrorResponse implements IApiErrorResponse {
  status: number
  message: string
  detail: string
  errors?: any

  constructor(init?: any) {
    Object.assign(this, init)
  }
}

export interface IWizardProps {
  nextStep?: number
  onSave?: (step: number) => void
}

export interface IStepProps {
  showreadonly: boolean
}

export interface ISelection {
  clear: boolean
  visible: boolean
}

export enum Mode {
  Default,
  Radio,
  Select,
}
export interface SharedControlProps {
  name: string
  label?: string
  ariaLabel?: string
  placeholder?: string
  required?: boolean
  tooltip?: string
  showreadonly?: boolean
  showOptional?: boolean
  visible?: boolean
  culture?: string
  language?: number
  dropDownCulturalDefault?: string
  dependent?: SharedControlProps
  cascadeTriggerValue?: string
  clearSelection?: boolean
  options?: SelectItem[] //In case there is a need to pass options from outside
  mode?: Mode
  p1Start?: string
  p1End?: string
  p1?: string
  p2?: string
  p2Start?: string
  p2End?: string
  reportInfoTitle?: string
  reportInfoP1?: string
  reportInfoItem1?: string
  reportInfoItem2?: string
  reportInfoItem3?: string
  reportInfoP2?: string
  reportInfoP3?: string
  culturalToolTip?: string
  employeeDescription?: string
  employeeAttributeLabel?: string
  title?: string
  className?: string
  content?: any
  hasError?: (any) => void
  onSelection?: (any) => void
}

export const BooleanOptions: SelectItem[] = [
  { key: 'yes', value: true, text: 'Yes', checked: null, parentkey: null },
  { key: 'no', value: false, text: 'No', checked: null, parentkey: null },
]

export interface IFormSubmission {
  submitted: boolean
  submitting?: boolean
}

export interface ISearch {
  term: string
}

export interface ISearchResult {
  name: string
  value: string
}

export interface IBookmarksType {
  type: string
}
export const Tooltips = {
  PhoneGeneralTooltip:
    "Phone including area code or mobile number<br/> Note: international numbers should commence with '0011' or '+'.",
  PhoneMFAResetTooltip:
    "Phone including area code or mobile number<br/> Note: international numbers should commence with '0011' or '+'. <br/>This is the phone number we use to contact you and to verify your identity when you call us. If you change this phone number, it will also reset the phone number you use to verify your account by SMS or phone call when you log in. <br/> The next time you log in, you'll be asked to set up a phone number to receive the SMS or phone call to verify your account.",
  PhoneMFAResetWithoutGeneralTooltip:
    "This is the phone number we use to contact you and to verify your identity when you call us. If you change this phone number, it will also reset the phone number you use to verify your account by SMS or phone call when you log in. <br/> The next time you log in, you'll be asked to set up a phone number to receive the SMS or phone call to verify your account.",
}

export const FormRegex = {
  Phone:
    /^(\+\d{8,18})$|^0011[\d]{8,18}$|^(1)[\d]{5}$|^(1)[\d]{9}$|^(0)[1-9][\d]{8}$/,
  PersonName: /^[a-zA-Z\-\'\s]*$/,
  Email:
    /^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/,
  PositiveNumber: /^\+?(\d+(\.(\d+)?)?|\.\d+)$/,
  ABN: /^(\d *?){11}$/,
  Postcode: /^[0-9]{4}$/,
  State: /\b([A-Za-z]{2,3})\b/,
  Date: /^(0[1-9]|1\d|2\d|3[01])\/(0[1-9]|1[0-2])\/(19|20)\d{2}$/,
  MinDate: /^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d$/,
  PhoneEx:
    /^(\+\d{8,18})$|^0011[\d]{8,18}$|^1[\d]{5}$|^1[\d]{9}$|^(\(0[1-9]\)|0[1-9]) ?[\d]{4} ?[\d]{4}$/,
}

export const IdleTime = 20

export const stripTags = (str: string) => {
  if (str === null || str === '' || str === undefined) {
    return str
  }
  return str.replace(/(<([^>]+)>)/gi, '')
}

export const createMarkup = (content: string) => {
  const clean = DOMPurify.sanitize(content)

  return { __html: clean }
}

export const santizeHtml = (content: string, config) => {
  const clean = DOMPurify.sanitize(content, config)
  return clean
}

export const createMarkupWithOption = (content: string, options: any) => {
  const clean = DOMPurify.sanitize(content, options)
  return { __html: clean }
}
